import React from "react";
import {connect} from "react-redux";
import BsDataTable from "components/data-table/BsDataTable";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeaderFilters from "components/panel/header/BsPanelHeaderFilters";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import BsPanel from "components/panel/BsPanel";
import {exportAllRentalsToCsv, loadAllRentals} from "core/actions/rental-actions";
import {ALL_RENTALS_TABLE} from "./all-rentals-table";
import AllRentalsFilters from "./AllRentalsFilters";
import Button from "@material-ui/core/Button";
import {Trans} from "react-i18next";

const queryString = require('query-string');

class AllRentals extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction,
      fields: {
        name: query.name != null ? query.name : '',
        bikeNumber: query.bikeNumber != null ? query.bikeNumber : '',
        systemName: query.systemName != null ? query.systemName : '',
        status: query.status != null ? (typeof query.status === "string" ? [query.status] : query.status) : []
      }
    };

    this.onLoadData(query);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({fields});
  }

  onHandleFilter = () => {
    const params = queryString.parse(this.props.location.search);
    params.name = this.state.fields.name;
    params.bikeNumber = this.state.fields.bikeNumber;
    params.systemName = this.state.fields.systemName;
    params.status = this.state.fields.status;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
  }

  onHandleClear = () => {
    const params = queryString.parse(this.props.location.search);
    delete params.name;
    delete params.systemName;
    delete params.bikeNumber;
    delete params.status;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
    this.setState({
      ...this.state,
      fields: {
        name: '',
        bikeNumber: '',
        systemName: '',
        status: []
      }
    })
  }

  onLoadData = (query) => {
    this.props.loadAllRentals(this.prepareQuery(query));
  }

  onRowClick = (row) => {
    this.props.history.push('/global/rental/' + row.id)
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }
    if (query.name) {
      query['client.firstName'] = query.name
      query['client.lastName'] = query.name
    }
    if (query.bikeNumber) {
      query['bike.number'] = query.bikeNumber;
    }
    if (query.systemName) {
      query['system.name'] = query.systemName;
    }
    if (query.status) {
      query.status = query.status instanceof Array ? query.status.join(',') : query.status
    }
    return query
  }

  export = () => {
    const query = queryString.parse(this.props.location.search);
    this.props.exportAllRentalsToCsv(this.prepareQuery(query));
  }

  render() {
    return (
        <BsPanel padding={true}>
          <BsPanelLoader show={this.props.loading}/>
          <BsPanelHeader>
            <BsPanelTitle action={
              <Button variant="outlined" type="button" onClick={this.export}>
                <Trans i18nKey="general.export"/>
              </Button>
            }>
              <Trans i18nKey="rentals.title"/>
            </BsPanelTitle>
          </BsPanelHeader>

          <BsPanelHeaderFilters onHandleFilter={this.onHandleFilter.bind(this)}
                                onHandleClear={this.onHandleClear.bind(this)}>
            <AllRentalsFilters fields={this.state.fields}
                               onHandleChange={this.handleChange.bind(this)}/>
          </BsPanelHeaderFilters>

          <BsDataTable location={this.props.location}
                       history={this.props.history}
                       order={this.state.direction}
                       orderBy={this.state.sort}
                       settings={ALL_RENTALS_TABLE}
                       content={this.props.rentals}
                       onRowClick={this.onRowClick}
                       onChangePage={this.onLoadData}
                       onChangeSize={this.onLoadData}
                       onRequestSort={this.onRequestSort}/>
        </BsPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    rentals: state.rental.allRentals,
    loading: state.rental.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadAllRentals: (query) => {
      dispatch(loadAllRentals(query));
    },
    exportAllRentalsToCsv: (query) => {
      dispatch(exportAllRentalsToCsv(query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AllRentals);
